<template>
  <div class="inspection-section">
    <el-table
      :data="sectionData.items"
      border
      style="width: 100%; margin-bottom: 10px;"
      size="small"
    >
      <el-table-column prop="code" label="序号" width="80" align="center" />
      <el-table-column prop="requirement" label="标准要求" min-width="400" />
      <el-table-column label="检验结果" min-width="200">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.result"
            placeholder="请输入检验结果"
            size="small"
            @input="updateData"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="section-summary">
      <span class="label">本项判定：</span>
      <el-radio-group v-model="sectionData.judgment" @change="updateData">
        <el-radio label="合格">合格</el-radio>
        <el-radio label="不合格">不合格</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InspectionSection',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        items: [],
        judgment: ''
      })
    }
  },
  data() {
    return {
      sectionData: {
        items: [],
        judgment: ''
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val && val.items) {
          this.sectionData.items = val.items
          this.sectionData.judgment = val.judgment || ''
        }
      }
    }
  },
  methods: {
    updateData() {
      this.$emit('input', {
        items: this.sectionData.items,
        judgment: this.sectionData.judgment
      })
    }
  }
}
</script>

<style scoped>
.inspection-section {
  margin-bottom: 15px;
}

.section-summary {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.section-summary .label {
  font-weight: bold;
  margin-right: 10px;
}
</style>
